export default "__VITE_PUBLIC_ASSET__b231ed80__"